import React, { useState } from 'react';
import { DropdownIcon } from '../appearence/icons/dropdown_icon';
import FiltersListItemMaxAndMin from './FiltersListItemMaxAndMin';
import FiltersListItemSelect from './FiltersListItemSelect';
import FiltersListItemCheckbox from './FiltersListItemCheckbox';
import { useTranslation } from 'react-i18next';
import { FILTER_TYPE_MAX_AND_MIN, FILTER_TYPE_SELECT } from '../constant';
import {FilterGroup, ItemsStorageService} from "./filtering/itemsStorageService";

interface FiltersListItemProps {
    itemsStorageService: ItemsStorageService,
    filterData: FilterGroup,
}

const FiltersListItem = ({ filterData, itemsStorageService }: FiltersListItemProps) => {
    const { i18n } = useTranslation();
    const [filterGroupIsOpen, setFilterGroupIsOpen] = useState <boolean> (false);

    const changeFilterItemOpenness = () => {
        setFilterGroupIsOpen(!filterGroupIsOpen);
    };

    return (
        <li key={filterData.filterGroupName} className="product__dropdown-item" >
            {filterData.filterType === FILTER_TYPE_SELECT ?
                <FiltersListItemSelect itemsStorageService={itemsStorageService} filterData={filterData} />
                :
                <>
                    <div className="block__content product__dropdown-title" onClick={changeFilterItemOpenness}>
                        <h3 >{i18n.t(`app.page.product.filters.${filterData.filterGroupName}`)}</h3>
                        <DropdownIcon nameOfClass={`product__dropdown-icon ${filterGroupIsOpen ? 'product__dropdown-icon_active' : ''}`} 
                            handleClick={() => null} value={null}/>
                    </div>
                    {filterGroupIsOpen ?
                        <ul className="product__dropdown-content scroll">
                            {itemsStorageService.getCurrentFiltersByGroup(filterData.filterGroupName).map(item => (
                                <React.Fragment key={item.filterName + 'key'}>
                                    {item.filterType === FILTER_TYPE_MAX_AND_MIN ?
                                        <FiltersListItemMaxAndMin itemsStorageService={itemsStorageService} filterData={item} />
                                        :
                                        <FiltersListItemCheckbox itemsStorageService={itemsStorageService} filterData={item} />}
                                </React.Fragment>
                            ))}
                        </ul>
                        : null}
                </>}
        </li>
    );
};

export default FiltersListItem;
